<template>
  <div class="content">
          <img  src="../../assets/images/login/logo1.png" alt="" style="margin-top:2rem;height:10rem;">

      <div class="title">{{ demoSystemHead.title }}</div>
      <!-- <div class="des-style">{{ demoSystemHead.description }}</div> -->
    <div>
      <div class="applyButton" @click="applyClick">点击试用</div>
      <div class="applyText">申请试用账号获得完整版功能。</div>
    </div>
  </div>
</template>
<script>
import demoSystemHead from 'demoSystemHead'
import applyTrialUrl from 'applyTrialUrl'
export default {
  name: 'Title',
  data () {
    return {
      demoSystemHead
    }
  },
  methods: {
    applyClick () {
      window.open(applyTrialUrl)
    }
  }
}
</script>

<style  lang="scss" scoped>
.content {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  user-select: none;
  .applyButton {
    width: 14rem;
    height: 3.5rem;
    background: linear-gradient(
      315deg,
      #de7e00 0%,
      rgba(255, 213, 6, 0.91) 100%
    );
    border-radius: 2px;
    margin-top: 3.5rem;
    line-height: 3.5rem;
    text-align: center;
    cursor: pointer;
    font-size: 1.5rem;
    &:active {
      background: linear-gradient(
        315deg,
        #c46f00 0%,
        rgba(214, 179, 0, 0.91) 100%
      );
    }
  }
  .applyText {
    line-height: 2rem;
  }
}
.title,
.des-style {
  width: 90%;
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.6);
}
.title {
  font-size: 2.4rem;
  line-height: 10rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}
.des-style {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  line-height: 1.6rem;
}
</style>
